export type PitchAssignmentMode = "fixed" | "category" | "auto";

export const PITCH_ASSIGNMENT_MODES: {
  value: PitchAssignmentMode;
  label: string;
  description: string;
}[] = [
  {
    value: "fixed",
    label: "Fester Platz",
    description: "Ein bestimmter Stellplatz ist verbindlich reserviert.",
  },
  {
    value: "auto",
    label: "Automatisch",
    description: "Platzkategorie ist fest, der Stellplatz wird laufend für optimale Auslastung vorgeschlagen.",
  },
];

/** Betreiber-Buchung: fester Platz oder automatische Vorschlagsoptimierung. */
export const OPERATOR_PITCH_ASSIGNMENT_MODES = PITCH_ASSIGNMENT_MODES;

export function pitchAssignmentLabel(mode: PitchAssignmentMode | string): string {
  if (mode === "category") {
    return PITCH_ASSIGNMENT_MODES.find((m) => m.value === "auto")?.label ?? "Automatisch";
  }
  return PITCH_ASSIGNMENT_MODES.find((m) => m.value === mode)?.label ?? mode;
}

export function isFlexiblePitchAssignment(mode: PitchAssignmentMode | string): boolean {
  return mode === "auto" || mode === "category";
}

export type PitchPlanStatus = "fixed" | "suggested" | "occupied" | "open";

/** Ob der Stellplatz verbindlich fixiert ist (keine automatische Umplanung). */
export function isPitchFixed(mode: PitchAssignmentMode | string): boolean {
  return mode === "fixed";
}

/** Aktueller Planungsstatus des Stellplatzes für die Anzeige. */
export function pitchPlanStatus(
  booking: {
    pitch_id: string | null;
    pitch_assignment_mode: PitchAssignmentMode | string;
    status?: string;
  },
): PitchPlanStatus {
  if (booking.status === "checked_in" && booking.pitch_id) return "occupied";
  if (isPitchFixed(booking.pitch_assignment_mode)) return "fixed";
  if (booking.pitch_id) return "suggested";
  return "open";
}

export function pitchPlanStatusLabel(status: PitchPlanStatus): string {
  switch (status) {
    case "fixed":
      return "Fest";
    case "suggested":
      return "Vorschlag";
    case "occupied":
      return "Belegt";
    default:
      return "Offen";
  }
}

export function pitchPlanStatusDescription(status: PitchPlanStatus): string {
  switch (status) {
    case "fixed":
      return "Der Stellplatz ist verbindlich und wird nicht automatisch geändert.";
    case "suggested":
      return "Vorgeschlagener Stellplatz – wird bei jeder Optimierung neu berechnet.";
    case "occupied":
      return "Gast ist eingecheckt – der Stellplatz ist belegt und kann nicht mehr geändert werden.";
    default:
      return "Noch kein Stellplatz vorgeschlagen.";
  }
}

/** Stellplatz passt zur gebuchten Platzkategorie (inkl. „ohne Kategorie“). */
export function pitchMatchesBookingCategory(
  pitchCategoryId: string | null,
  pitchCategoryIdOnPitch: string | null,
): boolean {
  if (pitchCategoryId == null) return pitchCategoryIdOnPitch == null;
  return pitchCategoryIdOnPitch === pitchCategoryId;
}
